//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

(function () {
  const contentLibrary = angular.module('curalate');
  let inputText = null;
  contentLibrary.component('contentLibraryQuickSearchFilter', {
    bindings: {},
    template: require('@legacy-components/content/content-library-quick-search-filter/content-library-quick-search-filter.html'),
    controller: [
      '$element',
      '$scope',
      '$state',
      '$timeout',
      'SearchFilterService',
      'SEARCH_FILTERS',
      function (
        $element,
        $scope,
        $state,
        $timeout,
        SearchFilterService,
        SEARCH_FILTERS,
      ) {
        const SEARCH_TEXT_FILTER = 'searchText';
        const filterSetName =
          SEARCH_FILTERS.COLLECTION_CONTENT_FILTERS_QUICK_SEARCH;

        const focusSearchInput = () => {
          $timeout(() => {
            const searchInput = $element.find(
              '#content-library-quick-search-filter-input',
            );
            searchInput.trigger('focus');
          }, 0);
        };

        this.searchTextChanged = () => {
          SearchFilterService.setFilter(filterSetName, SEARCH_TEXT_FILTER, [
            this.freeFormTextSearch,
          ]);
          inputText = this.freeFormTextSearch;
        };

        this.clearSearchText = () => {
          this.freeFormTextSearch = null;
          inputText = null;
          SearchFilterService.setFilter(filterSetName, SEARCH_TEXT_FILTER, [
            this.freeFormTextSearch,
          ]);

          focusSearchInput();
        };

        this.$onInit = () => {
          this.freeFormTextSearch = inputText;
          SearchFilterService.registerNewFilterSet(filterSetName, []);
          SearchFilterService.setFilter(filterSetName, SEARCH_TEXT_FILTER, [
            this.freeFormTextSearch,
          ]);
        };

        this.$onDestroy = () => {
          SearchFilterService.unregisterFilterSet(filterSetName);
        };
      },
    ],
  });
})();
